<template>
  <div></div>
</template>

<script>
export default {
  name: 'ProfileIndex',
  data () {
    return {

    }
  },
  mounted() {

  },
  computed: {
    user () {
      return this.$store.getters.user
    },

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>